import { Typography,Box } from "@mui/material";
import { useState,useEffect } from "react";
import CoursesBlog from "../../../../Blog/courses-blog.component";
import { getCoursesThirdCard } from "../../../../../utils/firebase/firebase.utils";
import { Helmet } from "react-helmet-async";

const CoursesThirdCard = ()=>{

    const [courseData,setCourseData] = useState([]);

    useEffect(()=>{
        const getData = async()=>{
            const arrayData = await getCoursesThirdCard();
            const{data} = arrayData;
            setCourseData(data.reverse());
        
        }

        getData();
        
        
    },[])




    return(
        <>
        <Helmet>
                <title> WBCS Correspondence Courses | Ahguide  </title>
                <meta name="description" content="For the aspirants of distant areas or working professionals who are unable to make use of classroom guidance program, Correspondence Course is the first choice." />        
                <link rel="canonical"  href="https://www.ahguide.in/wbcs-correspondence-courses" />
            </Helmet>
        <Box>
            <Typography sx={{textAlign:"center",marginTop:'20px'}} variant="h3" component="div">
                WBCS Correspondence Courses
            </Typography>
            {
                courseData.map((data)=>{
                    return  <CoursesBlog key={data.title} courseData= {data}  />
                })
            }

        </Box>
        </>
    )

}

export default CoursesThirdCard;